<template>
  <!-- View Legal basis modal template -->
  <b-modal ref="view-io" hide-footer @hide="hideIOModal">
    <div class="d-block text-center">
      <h4 qid="update-tp-title">
        {{ $t('processes.information_obligation.view.title') }}
      </h4>
    </div>
    <b-alert v-if="error.length"
             show
             variant="danger"
             qid="create-p-error"
    >
      {{ error }}
    </b-alert>

    <label class="mt-3">
      {{ $t('processes.information_obligation.view.name') }}
    </label>
    <br>
    <span v-if="object.information_obligation" qid="io-name">
      {{ object.information_obligation.name }}
    </span>
    <br>

    <label class="mt-3" v-if="object.information_obligation && object.information_obligation.description">
      {{ $t('processes.information_obligation.create.io_description_label') }}
    </label>
    <br>
    <span v-if="object.information_obligation && object.information_obligation.description" qid="io-description">
      <span class="text-formatted">
        {{ object.information_obligation.description }}
      </span>
    </span>
    <br>

    <div class="mt-4"
         v-if="object.information_obligation && object.information_obligation.media && object.information_obligation.media.length"
    >
      <p class="text-dark">
        {{ $t('attachments.label') }}
      </p>
      <p v-for="(file, index) in object.information_obligation.media">
        <span class="mr-3 float-right text-muted cursor-pointer"
              @click="downloadMedia(file)"
              qid="download-media"
        >
          <font-awesome-icon icon="cloud-download-alt" />
        </span>
        <a @click="downloadMedia(file)" qid="create-tp-media-item">
          {{ file.file_name }}
        </a>
      </p>
      <br>
    </div>
    <div class="mt-4"
         v-if="object.information_obligation && object.information_obligation.links && object.information_obligation.links.length"
    >
      <p class="text-dark">
        {{ $t('links.label') }}
      </p>
      <div v-if="object.information_obligation.links">
        <p v-for="(link, index) in object.information_obligation.links" >
          <a :href="link.url" target="_blank" qid="create-tp-link-item">
            {{ link.name ? link.name : link.url }}
          </a>
        </p>
      </div>
      <br>
    </div>

    <b-button class="mt-4 float-right"
              variant="success"
              @click="hideIOModal"
              qid="create-p-cancel-button"
    >
      {{ $t('processes.legal_basis.view.close') }}
    </b-button>
    <br>

  </b-modal>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'InformationObligationViewModal',
    data: function() {
      return {
        error: '',
        processGroup: [],
        showInput: false,
        loadingItems: false,
        showArticleDescription: false
      }
    },
    props: {
      object: {
        type: [Object,Array]
      },
      showModal: {
        type: Boolean
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getMedia() {
        return this.object.media
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showIOModal()
        }
      }
    },
    methods: {
      showIOModal() {
        let self = this
        this.$refs['view-io'].show()
      },
      hideIOModal() {
        this.error = ''
        this.$emit('closeViewModal');
        this.showArticleDescription = false;
        this.$refs['view-io'].hide()
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
    },
    components: {

    },
    created () {

    }
  }
</script>
